/* ========================================================================
   Team search
 ========================================================================== */

app.teamSearch = (function () {
  'use strict';

  let selectedCareType = null;
  let defaultCareType = null;
  let template = null;
  let resultContainer = null;
  let loader = null;
  let outputContainer = null;
  let noResultContainer = null;
  let careTypeField = null;
  let postalCodeField = null;
  let validate = null;
  let contactPage = null;

  function init() {
    const form = document.querySelector('.js-teamSearchForm');
    if (form.length === 0) return;

    defaultCareType = form.dataset.careType;
    template = document.querySelector('#teamSearchTemplate');
    resultContainer = document.querySelector('.js-teamSearchResult');
    loader = document.querySelector('.js-teamSearchLoader');
    outputContainer = resultContainer.querySelector('.teamSearch__result__output');
    noResultContainer = resultContainer.querySelector('.teamSearch__result__noresult');
    careTypeField = form.querySelector('[name="careType"]');
    postalCodeField = form.querySelector('[name="postalCode"]');

    validate = new Bouncer('form.js-teamSearchForm', {
      disableSubmit: true,
    });

    contactPage = document.querySelector('[data-contact-page]');

    document.addEventListener('bouncerFormValid', (event) => {
      if (event.target.classList.contains('js-teamSearchForm') == false) return;

      // get care type
      selectedCareType = careTypeField ? careTypeField.value : defaultCareType;

      // show loader
      loader.classList.add('is-loading');

      // collapse results
      util.slideUp(resultContainer, 250);

      // execute search with a short delay
      window.setTimeout(() => {
        searchTeam(selectedCareType, postalCodeField.value);
      }, 1000);
    });
  }

  function searchTeam(careType, postalCode) {
    // DATALAYER
    window.dataLayer.push({
      event: 'teamSearch',
      pageUrl: window.location.pathname,
      careType: careType,
    });

    executeSearch(careType, postalCode).then((result) => {
      // clear previous result
      noResultContainer.style.display = 'none';
      outputContainer.style.display = 'none';
      outputContainer.innerHTML = '';

      if (result.hasResult) {
        // show result using Mustache template
        outputContainer.innerHTML = Mustache.render(template.innerHTML, result);
        outputContainer.style.display = 'block';

        // show result
        util.slideDown(resultContainer, 250);
      } else {
        // show result
        noResultContainer.style.display = 'block';
        util.slideDown(resultContainer, 500);
      }

      // hide loader
      loader.classList.remove('is-loading');

      if (contactPage && contactPage.getAttribute('aria-hidden') === 'false') {
        contactPage.setAttribute('aria-hidden', 'true');
        contactPage.style.display = 'none';
      }
    });
  }

  function executeSearch(careType, postalCode) {
    return fetch('/umbraco/api/teamsearch/find?careType=' + careType + '&postalCode=' + postalCode, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();

util.onDocumentReady(function () {
  app.teamSearch.init();
});
